<template>
  <div>
    <div class="bg-white">
      <div class="padding-sm">
        <van-field
            v-model="model.content"
            :autosize="autoHeight"
            maxlength="100"
            type="textarea"
            placeholder="说说分享心得..."
            show-word-limit
            class="contentField"
        />
      </div>

      <div class="text-center">
        <van-tabs v-model="selectType" border color="#04ade0" @change="tabsChange">
          <van-tab title="图片" name="img" class="padding-top padding-lr">
<!--            <van-uploader v-model="model.photoUrls" multiple :max-count="6" upload-text="点击上传"-->
<!--                          preview-size="100" :after-read="photoAfterRead"/>-->

            <UploadImg class="module" @uploadimg="uploadimg" :imgArr="model.photoUrls" :imgAmount="6"></UploadImg>
          </van-tab>
          <van-tab title="视频" name="video" class="padding-top">
            <template v-if="model.video.length == 0">
              <van-uploader v-model="model.video" accept="video/*" :max-count="1"
                            :max-size="15 * 1024 * 1024" @oversize="onOversize" :after-read="videoRead">
                <van-button class="uploadButton">上传视频</van-button>
              </van-uploader>
            </template>
            <template v-else>
              <video :src="localVideo"
                     controls="true" style="width: 80%;height: 200px"></video>
            </template>
            <template v-if="model.video.length > 0">
              <div class="btn-rerecording" @click="model.video = []">
                <van-icon name="replay" size="14"/>
                重新上传
              </div>
            </template>
          </van-tab>
          <van-tab title="语音" name="audio" class="padding-top">
            <van-cell-group :border=false>
              <van-cell style="padding: 0;">
                <template v-if="model.audio == null">
                  <div class="uploadButton record-status">
                    <input ref="input-audio" type="file" @change="onSelectAudio">
                    上传录音
                  </div>
                </template>
                <template v-else>
                  <template v-if="player.status == 0">
                    <div class="uploadButton record-status" @click="playAudio">播放录音</div>
                  </template>
                  <template v-if="player.status == 1">
                    <div class="uploadButton record-status" @click="stopAudio">停止播放</div>
                  </template>
                </template>
              </van-cell>
              <van-cell v-if="model.audio != null">
                <div class="text-center">
                  <div class="btn-rerecording" @click="model.audio = null">
                    <van-icon name="replay" size="14"/>
                    重新上传
                  </div>
                </div>
              </van-cell>
            </van-cell-group>
          </van-tab>
        </van-tabs>
        <div class="text-center padding-sm">
          <span style="color: red;font-size: 12px">注意：图片/视频/语音只能上传一种</span>
        </div>
      </div>

      <div class="margin-top-sm">
        <van-button class="addButton" block @click="submit">发布</van-button>
      </div>

    </div>
  </div>

</template>

<script>
import Vue from 'vue';
import {Button, Toast, Dialog, Field, Icon, Uploader, Tab, Tabs, CellGroup, Cell} from 'vant';
import {addPost} from '@/api/clerk/post'
import {audioToMp3} from "@/api/file"
import lrz from "lrz";
import UploadImg from "@/views/clerk/UploadImg";


Vue.use(Button)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Icon)
    .use(Uploader)
    .use(Tab)
    .use(Tabs)
    .use(CellGroup)
    .use(Cell)


export default {
  name: 'post-add',
  components:{
    UploadImg
  },

  data() {
    return {
      autoHeight: {minHeight: 100},
      selectType: 'img',
      selectLastType: 'img',
      localVideo: null,
      model: {
        content: null,
        photoUrls: [],
        video: [],
        audio: null
      },
      player: {
        status: 0,
        audio: null
      }
    }
  },
  methods: {
    uploadimg(imgarr){
      this.model.photoUrls = imgarr
    },

    videoRead(file) {
      const vm = this
      let reader = new FileReader();
      reader.readAsDataURL(file.file);
      reader.onload = function (e) {
        vm.localVideo = e.currentTarget.result
      }
    },
    onOversize(file) {
      Toast('文件大小不能超过15M');
    },
    // 图片读取后
    photoAfterRead(file) {
      let files = []
      if (!file.length) {
        files.push(file)
      } else {
        files = file
      }
      for (let item of files) {
        // 压缩图片
        lrz(item.file, {
          width: 800
        }).then(function (res) {
          item.content = res.base64
        })
      }
    },
    onSelectAudio() {
      const vm = this
      const files = this.$refs['input-audio'].files
      if (files.length > 0) {
        const file = files[0]
        if (['audio/x-mpeg', 'audio/mpeg', 'audio/mp3', 'audio/x-m4a', 'audio/mp4a-latm', 'audio/vnd.dlna.adts', 'audio/aac'].indexOf(file.type) == -1) {
          if (file.name != null && file.name.lastIndexOf('.') != -1) {
            let ext = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase()
            if (['mp3', 'm4a', 'amr'].indexOf(ext) == -1) {
              return Toast('仅支持请上传m4a或mp3格式')
            }
          } else {
            return Toast('仅支持请上传m4a或mp3格式')
          }
        }
        if (file.size > 2 * 1024 * 1024) {
          return Toast('音频大小不能超过2M')
        }
        Toast.loading({
          mask: true,
          duration: 0,
          message: '音频上传中'
        })
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          audioToMp3(e.target.result).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              const base64 = 'data:audio/mpeg;base64,' + data.audio
              vm.model.audio = base64
              vm.player.status = 0
            } else {
              Dialog.alert({
                title: '上传录音失败',
                message: data.msg
              })
            }
          })
        }
      }
    },
    // 播放录音
    playAudio() {
      this.player.audio = new Audio(this.model.audio)
      this.player.audio.play()
      this.player.status = 1
      // 播放结束事件
      this.player.audio.onended = () => {
        this.player.status = 0
      }
    },
    // 停止播放录音
    stopAudio() {
      this.player.audio.pause()
      this.player.status = 0
    },
    submit() {
      if ((this.model.content == null || this.model.content == '') && this.model.photoUrls.length == 0
          && this.model.audio == null && this.model.video.length == 0) {
        return Toast('发布内容不为空');
      }
      if (this.model.photoUrls.length > 6) {
        return Toast('最多上传6张照片');
      }
      Toast.loading({
        mask: true,
        message: '请稍候...'
      })
      addPost(
          this.model.content,
          this.model.photoUrls,
          this.model.video,
          this.model.audio).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.localVideo = null
          this.model.content = null
          this.model.photoUrls = []
          this.model.video = []
          this.model.audio = null
          this.player.status = 0
          this.player.audio = null
          Dialog.alert({
            title: '发布成功'
          })
          this.$router.back()
        } else {
          Dialog.alert({
            title: '发布失败',
            message: data.msg
          })
        }
      })
    },
    tabsChange(name, title) {
      let isClear = false
      if (this.selectLastType == 'img' && this.model.photoUrls.length > 0) {
        isClear = true
      } else if (this.selectLastType == 'video' && this.model.video.length > 0) {
        isClear = true
      } else if (this.selectLastType == 'audio' && this.model.audio != null) {
        isClear = true
      }
      if (isClear) {
        Dialog.confirm({
          title: '温馨提示',
          message: '切换到' + title + '会清空当前选择的的数据，确定切换吗?',
        }).then(() => {
            if (this.selectLastType == 'img') {
                this.model.photoUrls = []
            } else if (this.selectLastType == 'video') {
              this.model.video = []
            } else if (this.selectLastType == 'audio') {
              this.model.audio = null
            }
            this.selectLastType = name
          })
          .catch(() => {
            this.selectType = this.selectLastType
          });
      }else {
        this.selectLastType = name
      }
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.returnClose {
  font-size: 16px;
  color: darkgrey;
}

.addButton {
  //width: 100%;
  //height: 35px;
  //border-radius: 30px;
  background: #04ade0;
  font-size: 15px;
  color: white;
  border: none;
}

.contentField {
  font-size: 16px;
  border: 1px solid #efefef;
}

.uploadButton {
  display: inline-block;
  line-height: 44px;
  min-width: 92px;
  height: 44px;
  border-radius: 30px;
  font-size: 15px;
  background: #04ade0;
  color: white;
  white-space: nowrap;
}

.record-status {
  text-align: center;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 92px;
    height: 100%;
    overflow: hidden;
    cursor: pointer;
    opacity: 0;
    z-index: 3;
  }

  .btn-rerecording {
    display: inline-flex;
    color: #333;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    align-items: center;

    .van-icon {
      margin-right: 3px;
    }
  }
}

/deep/ .van-cell:after {
  border: none;
}


</style>
